import DOMPurify from 'dompurify';

const config = {
  ADD_ATTR: ['target'],
};

export const sanitizedContent = (content: string) => ({
  __html: DOMPurify.sanitize(content, config),
});
